import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import _, {filter} from 'lodash';
import {ModalBody, ModalHeader, UncontrolledTooltip} from "reactstrap";
import {observer} from "mobx-react";
import {UrlSelector} from '../../components/index';
import {PostEditorFormFields} from "./formShapes";



export default observer(class AddPhotoVideoAttachment extends Component {

  static propTypes = PostEditorFormFields;

  addUrl = () => {
    const componentToRender = <Fragment>
      <ModalHeader toggle={() => this.props.closeModal()}>
        Enter a link
      </ModalHeader>
      <ModalBody>
        <UrlSelector
          onCancel={() => this.props.closeModal()}
          onComplete={(url) => {
            this.props.closeModal();
            this.props.onChangeSetObject({attachments: _.concat(this.props.values.attachments, {attachmentType: 'Link', url: url})});
          }
          }/>
      </ModalBody>
    </Fragment>;

    this.props.openModal(componentToRender)
  };

  render() {
    const { config } = this.props;
    const attachments = !!this.props.values.attachments ? this.props.values.attachments : [];
    const linkCount = filter(attachments, (x) => x.attachmentType === 'Link').length;
    const exceededMaxLinks = linkCount >= this.props.config.maxNumberOfLinks;
    const disabled = !this.props.config.canHaveMixedMedia && linkCount <= 0 && attachments.length;

    return (
      !config.disableAttachments ?
        <span id="uploadLink" >
          <a className={`p-2 d-flex flex-row justify-content-between clickable text-secondary ${disabled || exceededMaxLinks ? 'btn disabled' : ''}`} onClick={this.addUrl}>
            <i className="far fa-link attachment-link"/>
            <div className="pl-2">
              Add Link
            </div>
          </a>
          {(disabled || exceededMaxLinks) && <UncontrolledTooltip placement="top" target="uploadLink">
            {exceededMaxLinks &&
            <span>
                {this.props.provider} only supports {this.props.config.maxNumberOfLinks} link per post.
              </span>
            }
            {disabled &&
            <span>
                You are not able to have mixed attachments for {this.props.provider}
              </span>
            }
          </UncontrolledTooltip>}
        </span>
      : <div/>
    );
  }
})
